export enum FaxDestination {
  FaxFolder = 'FaxFolder',
  Inbox = 'Inbox',
}
